import { render, staticRenderFns } from "./pincode-item-page.vue?vue&type=template&id=6ccfe0b7&scoped=true&"
import script from "./pincode-item-page.vue?vue&type=script&lang=js&"
export * from "./pincode-item-page.vue?vue&type=script&lang=js&"
import style0 from "./pincode-item-page.vue?vue&type=style&index=0&id=6ccfe0b7&lang=scss&scoped=true&"
import style1 from "./pincode-item-page.vue?vue&type=style&index=1&id=6ccfe0b7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ccfe0b7",
  null
  
)

export default component.exports
import {QCard,QCardSection,QIcon,QInput,QCardActions,QBtn,QSpinnerIos,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QCardSection,QIcon,QInput,QCardActions,QBtn,QSpinnerIos})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
